import { Button, Spin, TableColumnsType, Tooltip } from 'antd'
import Axios from 'axios'
import moment from 'moment'
import React from 'react'
import { saveAs } from 'file-saver'
import Table from '../../component/table'

const downloadZipFile = (reportId: string) => {
    Axios.get('/data/download-report', {
        params: {
            reportId,
        },
        responseType: 'blob',
    })
        .then(res => {
            saveAs(res.data, 'data.zip')
        })
        .catch(err => console.error)
        .finally(() => {})
}

const columns = (): TableColumnsType => {
    return [
        {
            title: 'Start',
            dataIndex: 'start',
            sorter: (a: any, b: any) => (a.start > b.start ? -1 : 1),
        },
        {
            title: 'End',
            dataIndex: 'end',
            sorter: (a: any, b: any) => (a.end > b.end ? -1 : 1),
        },
        {
            title: 'Download',
            dataIndex: 'finish',
            render: (finish: any, record: any) =>
                finish === '1' ? (
                    <Button
                        type="primary"
                        onClick={() => {
                            downloadZipFile(record._id)
                        }}
                    >
                        Download
                    </Button>
                ) : (
                    <Button type="primary" disabled>
                        {`Processing (${record.downloadProgress.downloadProgress})`}
                    </Button>
                ),
            sorter: (a: any, b: any) => (a.finish > b.finish ? -1 : 1),
        },
        {
            title: 'Platform',
            dataIndex: 'platform',
            filters: [
                {
                    text: 'Lora',
                    value: 'lora',
                },
                {
                    text: 'Onenet',
                    value: 'onenet',
                },
            ],
            filterMultiple: true,
            onFilter: (value: string | number | boolean, record: any) => record.platform.indexOf(value) === 0,
        },
        {
            title: 'District',
            dataIndex: 'district',
            sorter: (a: any, b: any) => (a.district > b.district ? -1 : 1),
        },
        {
            title: 'Title',
            dataIndex: 'contains',
            render: (contains: any) => (
                <Tooltip placement="topLeft" title={contains} overlayStyle={{ maxWidth: '800px' }}>
                    {contains.length > 70 ? contains.substring(0, 70) + '...' : contains}
                </Tooltip>
            ),
        },
        {
            title: 'Paginate',
            dataIndex: 'paginate',
            render: (paginate: any) => (paginate === true ? 'Yes' : 'No'),
            sorter: (a: any, b: any) => (a.paginate > b.paginate ? -1 : 1),
        },
        {
            title: 'No Data',
            dataIndex: 'noData',
            render: (noData: any) => (noData === true ? 'Yes' : 'No'),
            sorter: (a: any, b: any) => (a.noData > b.noData ? -1 : 1),
        },
        {
            title: 'Installed',
            dataIndex: 'installed',
            render: (installed: any) =>
                installed.length === 0 || installed.length === 2
                    ? ''
                    : installed[0].charAt(0).toUpperCase() + installed[0].slice(1),
            sorter: (a: any, b: any) => (a.noData > b.noData ? -1 : 1),
        },
        {
            title: 'Created Time',
            dataIndex: 'createdAt',
            sorter: (a: any, b: any) => (a.createdAt > b.createdAt ? -1 : 1),
        },
    ]
}

interface IProps {}

const RawDataList: React.FC<IProps> = props => {
    const [state, setState] = React.useState({
        loading: false,
        data: [] as any[],
    })

    React.useEffect(() => {
        fetch()

        const interval = setInterval(() => {
            fetch()
        }, 1000)
        return () => {
            clearInterval(interval)
        }
    }, [])

    const fetch = () => {
        Axios.get('data/report-list', {})
            .then(res => {
                const data = res.data.map((row: any, index: number) => {
                    row.key = index
                    row.createdAt = moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss')
                    row.start = moment(row.start).format('YYYY-MM-DD HH:mm:ss')
                    row.end = moment(row.end).format('YYYY-MM-DD HH:mm:ss')

                    return row
                })
                setState(prev => ({ ...prev, data }))
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {})
    }

    return (
        <Spin spinning={state.loading}>
            <div>
                <Table columns={columns()} data={[...state.data]} />
            </div>
        </Spin>
    )
}

export default RawDataList
